import styled from 'styled-components'

export const Action = styled.button`
    height: 40px;
    box-sizing: border-box;
    font-weight: 700;
    font-size: 12px;
    color: #F3123C;
    flex: 1;
    cursor: pointer;
`
